// South Africa safari/holiday packages — relocated out of the SouthAfrica.js
// component so it can be a single source consumed by the page, the /safaris hub
// (via data/destinations), and the AI planner's knowledge base.
// `icon` is a lucide-react icon NAME (string); the page maps it to a component.
export const safariPackages = [
  {
    id: 1,
    title: "Cape Town & Wine Country Escape",
    duration: "6 Days",
    destinations: ["Cape Town", "Stellenbosch", "Franschhoek"],
    price: "$1,899",
    category: "Luxury & Wine",
    rating: 4.9,
    reviews: 127,
    image: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    icon: "Wine",
    bestFor: "Couples, groups, and wine lovers looking for a relaxing getaway",
    highlights: [
      "Table Mountain & Cape Peninsula adventure",
      "Premium wine tasting in Stellenbosch & Franschhoek",
      "Robben Island & V&A Waterfront exploration",
      "Optional shark cage diving & helicopter rides"
    ],
    itinerary: [
      { day: 1, title: "Arrival in Cape Town", activities: "City tour, V&A Waterfront, Robben Island (optional)" },
      { day: 2, title: "Table Mountain & Cape Peninsula", activities: "Boulders Beach, Cape Point" },
      { day: 3, title: "Wine Country Tour", activities: "Full-day wine tasting in Stellenbosch & Franschhoek" },
      { day: 4, title: "Shopping & Leisure", activities: "Canal Walk Mall or luxury spa experience" },
      { day: 5, title: "Adventure Day", activities: "Shark cage diving, paragliding, or scenic helicopter ride" },
      { day: 6, title: "Departure", activities: "Free time before flight" }
    ]
  },
  {
    id: 2,
    title: "Johannesburg & Sun City Entertainment",
    duration: "5 Days",
    destinations: ["Johannesburg", "Sun City"],
    price: "$1,299",
    category: "Entertainment & Gaming",
    rating: 4.7,
    reviews: 89,
    image: "https://images.unsplash.com/photo-1577948000111-9c970dfe3743?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    icon: "Star",
    bestFor: "Young travelers, party groups, & casino lovers",
    highlights: [
      "Soweto tour & Apartheid Museum",
      "Gold Reef City theme park experience",
      "Sun City Valley of Waves adventure",
      "Casino gaming & vibrant nightlife"
    ],
    itinerary: [
      { day: 1, title: "Arrival in Johannesburg", activities: "Soweto tour, Mandela House, Apartheid Museum" },
      { day: 2, title: "Gold Reef City Experience", activities: "Theme park, underground gold mine tour" },
      { day: 3, title: "Transfer to Sun City", activities: "Valley of Waves, casino, nightlife" },
      { day: 4, title: "Sun City Leisure", activities: "Spa, golf, water sports" },
      { day: 5, title: "Return & Departure", activities: "Last-minute shopping at Sandton City" }
    ]
  },
  {
    id: 3,
    title: "Cape Town & Durban Beach Holiday",
    duration: "7 Days",
    destinations: ["Cape Town", "Durban"],
    price: "$1,699",
    category: "Beach & Leisure",
    rating: 4.8,
    reviews: 156,
    image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    icon: "Waves",
    bestFor: "Beach lovers, families, and leisure travelers",
    highlights: [
      "Table Mountain & Cape Peninsula exploration",
      "Durban's Golden Mile beach experience",
      "uShaka Marine World adventure",
      "Water sports & ocean activities"
    ],
    itinerary: [
      { day: 1, title: "Cape Town Arrival", activities: "Table Mountain, V&A Waterfront, wine tasting" },
      { day: 2, title: "Cape Peninsula", activities: "Cape Peninsula & Boulders Beach penguins" },
      { day: 3, title: "Flight to Durban", activities: "Check into beachfront hotel, Golden Mile relaxation" },
      { day: 4, title: "Durban City Tour", activities: "Durban City Tour & uShaka Marine World" },
      { day: 5, title: "Adventure Day", activities: "Surfing, snorkeling, or boat cruise" },
      { day: 6, title: "Beach Leisure", activities: "Free beach day & water activities" },
      { day: 7, title: "Departure", activities: "Final beach morning & departure" }
    ]
  },
  {
    id: 4,
    title: "Shopping, Adventure & Nightlife Tour",
    duration: "6 Days",
    destinations: ["Johannesburg", "Pretoria", "Cape Town"],
    price: "$1,599",
    category: "Urban Adventure",
    rating: 4.6,
    reviews: 94,
    image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    icon: "Camera",
    bestFor: "Young adults, social groups, and shopaholics",
    highlights: [
      "Premium shopping at Sandton City",
      "Pretoria cultural exploration",
      "Cape Town adventure activities",
      "Vibrant nightlife experiences"
    ],
    itinerary: [
      { day: 1, title: "Johannesburg Arrival", activities: "Shopping at Sandton City, luxury dinner" },
      { day: 2, title: "Pretoria Tour", activities: "Menlyn Mall & Mandela Statue" },
      { day: 3, title: "Montecasino Night", activities: "Sun City or Montecasino nightlife experience" },
      { day: 4, title: "Cape Town Transfer", activities: "Table Mountain, Canal Walk Mall" },
      { day: 5, title: "Adventure Day", activities: "Skydiving, paragliding, or wine tasting" },
      { day: 6, title: "Departure", activities: "Optional last-minute shopping" }
    ]
  },
  {
    id: 5,
    title: "Cape Town & Victoria Falls Luxury",
    duration: "7 Days",
    destinations: ["Cape Town", "Victoria Falls"],
    price: "$2,899",
    category: "Luxury Experience",
    rating: 5.0,
    reviews: 203,
    image: "https://images.unsplash.com/photo-1621414050345-53db43f7e7ab?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3",
    icon: "Mountain",
    bestFor: "Luxury travelers, couples & honeymooners",
    highlights: [
      "Cape Winelands premium tour",
      "Victoria Falls helicopter experience",
      "Zambezi sunset river cruise",
      "Optional Chobe National Park safari"
    ],
    itinerary: [
      { day: 1, title: "Cape Town Arrival", activities: "Robben Island, V&A Waterfront dinner" },
      { day: 2, title: "Cape Winelands", activities: "Stellenbosch & Franschhoek wine tasting" },
      { day: 3, title: "Cape Peninsula", activities: "Cape Point, Boulders Beach" },
      { day: 4, title: "Victoria Falls", activities: "Zambezi sunset cruise" },
      { day: 5, title: "Falls Experience", activities: "Guided Victoria Falls Tour, optional helicopter ride" },
      { day: 6, title: "Safari Option", activities: "Chobe National Park River Safari or spa day" },
      { day: 7, title: "Departure", activities: "Final leisure time & departure" }
    ]
  }
];
